import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { selectActualFeatureFlags } from 'containers/App/selectors'

const PageWithSidebar = ({ className, children, Sidebar, keepUnderNewNav }) => {
  // Under the new platform navigation the global side nav is the single
  // navigation surface — suppress the page's secondary sidebar so there are
  // not two rails. Old shell (flag off) is unchanged.
  // Pages that have no tab conversion yet can opt out via keepUnderNewNav.
  const ff = useSelector(selectActualFeatureFlags)
  const hideSecondarySidebar = !!ff?.NEW_PLATFORM_NAV && !keepUnderNewNav

  return (
    <div className={`page-with-sidebar ${className}`}>
      {!hideSecondarySidebar && Sidebar}
      <div className="content" id="scrollable-container">
        {children}
      </div>
    </div>
  )
}

export default styled(PageWithSidebar)`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;

  .content {
    width: 100%;
    min-width: 0;
    height: 100%;
    min-height: 0;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .content > * {
    min-height: 0;
    flex: 1;
  }

  /* New nav scrolls .platform-nav-content. This shell's overflow:hidden and
     the inner .content scroller become the sticky containing block, so table
     headers scroll away with the rows. */
  .platform-nav-content & {
    overflow: visible;

    .content {
      overflow: visible;
    }
  }
`
